import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useUser } from "@clerk/clerk-react";
import { Users } from "lucide-react";
import { CharacterDetail } from "@/components/features/characters";
import { AuthPrompt } from "@/components/ui";
import { trackPageView } from "@/services/analytics";

export function CharacterDetailPage() {
  const { name = "" } = useParams<{ name: string }>();
  const decoded = decodeURIComponent(name);
  const navigate = useNavigate();
  const { user, isSignedIn, isLoaded } = useUser();

  useEffect(() => {
    trackPageView("Character Detail", "Character Detail", user?.id, {
      character: decoded,
    });
  }, [user?.id, decoded]);

  if (isLoaded && !isSignedIn) {
    return (
      <div className="p-6 md:p-8 max-w-5xl mx-auto">
        <AuthPrompt
          message="Sign up or log in to view this character"
          icon={Users}
        />
      </div>
    );
  }

  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto">
      <CharacterDetail
        name={decoded}
        onBack={() => navigate("/assets")}
      />
    </div>
  );
}
